import { Navigate } from "react-router-dom";

const Permissoes = () => <Navigate to="/configuracoes/perfis" replace />;

export default Permissoes;
